export function keysToLowerCase(obj) {
    const entries = Object.entries(obj)
        .map(([k, v]) => {
            if (k === 'WRC_PAW_mm') {
                return ['wrC_PAW_mm', v];
            }
            return [k, v];
        })
        .map(([k, v]) => {
            return [
                k.length ? k[0].toLowerCase() + k.substring(1) : k,
                v
            ]
        });

    return Object.fromEntries(entries)
}